import clsx from "clsx";

import { useStyles } from "../ReferenceItemPriceSelect.style";
import ShowText from "../../../Info/ShowText/ShowText";
import { CurrencyModule } from "../../../../util/Currency";
import ReferenceItemPriceSelectRowProperties from "./ReferenceItemPriceSelectRowProperties";
import {Tooltip} from '@material-ui/core';
import AddIcon from '@mui/icons-material/Add';

const ReferenceItemPriceSelectRowMedium: React.FC<ReferenceItemPriceSelectRowProperties> = ({ 
                                                                                              referenceItemPriceResponse, 
                                                                                              className, 
                                                                                              filter,
                                                                                              onReferenceItemSelect,
}) => {
  const classes = useStyles();

  const getText = () =>{
    if(referenceItemPriceResponse.referenceItemDescription==="")
    return "Sin descripcion"
    return referenceItemPriceResponse.referenceItemDescription
  }

  return (
    <div className={clsx(classes.reference_items_info_container)}>
      <Tooltip title={<h3>{getText()}</h3>}>
        <div key={referenceItemPriceResponse.referenceItemId} className={classes.column}> 
          <ShowText text={referenceItemPriceResponse.referenceItemName} textToHighlight={filter}/>
        </div>
      </Tooltip>
      <ShowText text={CurrencyModule.format(referenceItemPriceResponse.cost || 0)} className={classes.column}/>
      <Tooltip title={'Seleccionar'}>
        <div className={classes.column}>
          <AddIcon
              fontSize="small"
              onClick={() => onReferenceItemSelect(referenceItemPriceResponse)}
          />
        </div>
      </Tooltip>
      {/* <RoundedButton
          onClick={() => onReferenceItemSelect(referenceItemPriceResponse)}
          className={className}
          tooltip={"Seleccionar"}
          type={ButtonType.DEFAULT}
          icon={<AddIcon/>}
      /> */}
    </div>
  );
};
export default ReferenceItemPriceSelectRowMedium;
